
const authRoutes = {
  name: 'auth',
  component: () => import('modules/authentication/layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'authHome',
      component: () => import('modules/authentication/pages/Home.vue')
    },
    {
      path: '/login',
      name: 'authLogin',
      component: () => import('modules/authentication/pages/Login.vue')
    },
    {
      path: '/help',
      name: 'authHelp',
      component: () => import('modules/authentication/pages/Help.vue')
    }
  ]
}

export default authRoutes